/**
 * Created by wjjn3481 on 2017/7/18.
 */

export default {
    data () {
        return {
            urls: {
                positionList: '/position/vailList.api'
            },
            positionList: []
        }
    },
    methods: {
        fetchPositionList (onlyNotSuspended = false) {
            return this.$axios.get(onlyNotSuspended ? this.urls.positionList + '?state=1' : this.urls.positionList).then((res) => {
                this.positionList = res.result.list
                this.allPositionList = JSON.parse(JSON.stringify(res.result.list))
            }).catch(() => {})
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/operation/fetchPositionListMixin.js